export const educationData = [
	{
		id: 1,
		institution: "MIT Academy of Engineering,Pune",
		course: "Bachelor Degree",
		startYear: "2019",
		endYear: "2023",
	},
	{
		id: 2,
		institution: "Infinty Junior College of Science,Dhule",
		course: "Higher Secondary",
		startYear: "2017",
		endYear: "2019",
	},
	{
		id: 3,
		institution: "North Point School,Dhule",
		course: "Secondary School",
		startYear: "2007",
		endYear: "2017",
	},
];
